module.exports = __webpack_public_path__ + "img/Diapositivas.258ac723.svg";